<template>
  <div id="pers-tab3" name="hres31x-tab3" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">

    <!--Start Topic #1-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic1">
      <i class="fa fa-users icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31XC1']['300'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic1">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['20'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteempmt']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['30'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codcomp'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['40'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codpos'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['50'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codbrlc'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['60'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codempmt'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['70'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['typpayroll'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['80'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['typemp'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['90'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codcalen'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['100'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codjob'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['280'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['jobgrad'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['290'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codgrpgl'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['300'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteefstep']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['140'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['qtydtepr'] }} {{ labels['HRES31XC3']['150'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['160'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['qtyyear'] }} {{ labels['HRES31XC3']['170'] }}
          {{ detail['qtymonth'] }} {{ labels['HRES31XC3']['180'] }}
        </div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['190'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['email'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['110'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numlvl'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['120'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteeffex']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['130'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteeflvl']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['210'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteoccup']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['220'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numreqst'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['230'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['staemp'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['240'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['flgatten'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['250'] }}</div>
        <div class="col-xs-6 data-text">{{ setDateOutput(detail['dteefpos']) }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC3']['260'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numtelof'] }}</div>
      </div>

    </div>
    <!--End Topic #1-->
  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres31x-tab3',
  data () {
    return {
      subTopic1: true
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>


// WEBPACK FOOTER //
// tab3.vue?5fce2a12